import { AiOutlineHome, AiOutlineUserSwitch } from "react-icons/ai";
import { GiVendingMachine } from "react-icons/gi";
import { IoFastFoodOutline } from "react-icons/io5";
import { MdOutlinePayment, MdOutlineAdminPanelSettings } from "react-icons/md";
import { BsGraphUp } from "react-icons/bs";
import { ImQrcode } from "react-icons/im";
import { CgUserList } from "react-icons/cg";
import { RiMapPinUserLine } from "react-icons/ri";
import StoreIcon from "@mui/icons-material/StoreOutlined";
import { FaRegUser } from "react-icons/fa";
import { GrValidate } from "react-icons/gr";
import { MdDeliveryDining } from "react-icons/md";
import { MdOutlineFastfood } from "react-icons/md";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import KebabDiningIcon from "@mui/icons-material/KebabDining";
import TextsmsIcon from "@mui/icons-material/TextsmsOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import { BsBuildingFillGear } from "react-icons/bs";
import { MdAssignmentReturn } from "react-icons/md";
import { BsPersonVideo3 } from "react-icons/bs";
import HubIcon from '@mui/icons-material/Hub';
import "utils/protos";
import { AiOutlineGift } from "react-icons/ai";
import {
  LiaFileInvoiceDollarSolid,
  LiaMapMarkedAltSolid,
} from "react-icons/lia";
import { PiVan } from "react-icons/pi";
import { BsBuildings } from "react-icons/bs";

export const getDrawerMenu = (roles, inventorySettings) => {
  const menuItems = [
    {
      id: "navigation",
      title: "Navigation",
      children: [
        {
          id: "",
          title: "Dashboard",
          url: "",
          icon: AiOutlineHome,
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "machine",
      title: "Machine",
      collapsable: true,
      children: [
        {
          id: "machines",
          title: "Machines",
          url: "/machines",
          icon: GiVendingMachine,
          breadcrumbs: true,
        },
        {
          id: "product-analytics",
          title: "Product analytics",
          url: "/product-analytics",
          icon: HubIcon,
          breadcrumbs: true,
        },
      ],
    },
  ];

  if (roles.any(["super_admin", "admin", "machine_admin"])) {
    menuItems.push({
      id: "products",
      title: "Products",
      children: [
        {
          id: "product-category",
          title: "Product categories",
          url: "/product-category",
          icon: KebabDiningIcon,
          breadcrumbs: true,
        },
        {
          id: "products",
          title: "Manage products",
          url: "/products",
          icon: IoFastFoodOutline,
          breadcrumbs: true,
        },
        {
          id: "product-grouping",
          title: "Product grouping",
          url: "/product-grouping",
          icon: ImQrcode,
          breadcrumbs: true,
        },
        {
          id: "product-validation",
          title: "Product validation",
          url: "/product-validation",
          icon: GrValidate,
          breadcrumbs: true,
        },
        {
          id: "event-offers",
          title: "Event offers",
          url: "/event-offers",
          icon: AiOutlineGift,
          breadcrumbs: true,
        },
      ],
    });
  }

  if (roles.any(["super_admin"])) {
    menuItems.push({
      id: "payments",
      title: "Payments",
      children: [
        {
          id: "payment-methods",
          title: "Payment methods",
          url: "/payment-methods",
          icon: MdOutlinePayment,
          breadcrumbs: true,
        },
        // {
        //   id: "manage-payment-split",
        //   title: "Manage payment split",
        //   url: "/manage-payment-split",
        //   icon: AccountBalanceWalletIcon,
        //   breadcrumbs: true,
        // },
      ],
    });
  }

  if (roles.any(["super_admin", "admin", "machine_admin"])) {
    menuItems.push(
      {
        id: "reports",
        title: "Reports",
        children: [
          {
            id: "sales-report",
            title: "Sales report",
            url: "/sales-report",
            icon: BsGraphUp,
            breadcrumbs: true,
          },
          {
            id: "invoice-configuration",
            title: "Invoice Configuration",
            url: "/invoice-configuration",
            icon: LiaFileInvoiceDollarSolid,
            breadcrumbs: true,
          },
          // {
          //   id: "daily-settlements",
          //   title: "Daily settlements",
          //   url: "/daily-settlements",
          //   icon: AutoStoriesIcon,
          //   breadcrumbs: true,
          // },
        ],
      },
      {
        id: "ads",
        title: "Advertisement",
        children: [
          // {
          //   id: "ad-images",
          //   title: "Ad images",
          //   url: "/ad-images",
          //   icon: VrpanoIcon,
          //   breadcrumbs: true,
          // },
          {
            id: "ad-videos",
            title: "Ad videos",
            url: "/ad-videos",
            icon: OndemandVideoIcon,
            breadcrumbs: true,
          },
        ],
      }
    );
  }

  let inventoryItems = [];

  if (inventorySettings.stock_level === "super_admin") {
    if (roles.any(["super_admin"])) {
      inventoryItems.push(
        {
          id: "main-stock",
          title: "Main stock",
          url: "/main-stock",
          icon: FactoryIcon,
          breadcrumbs: true,
        },
        {
          id: "admin-stock",
          title: "Admin stock",
          url: "/admin-stock",
          icon: BsBuildings,
          breadcrumbs: true,
        },
        {
          id: "distributor-stock",
          title: "Distributor stock",
          url: "/distributor-stock",
          icon: PiVan,
          breadcrumbs: true,
        },
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: MdOutlineFastfood,
          breadcrumbs: true,
        }
      );
    } else if (roles.any(["admin"])) {
      inventoryItems.push(
        {
          id: "admin-stock",
          title: "Admin stock",
          url: "/admin-stock",
          icon: BsBuildings,
          breadcrumbs: true,
        },
        {
          id: "distributor-stock",
          title: "Distributor stock",
          url: "/distributor-stock",
          icon: PiVan,
          breadcrumbs: true,
        },
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        }
      );
    } else if (roles.any(["distributor"])) {
      inventoryItems.push(
        {
          id: "distributor-stock",
          title: "Distributor stock",
          url: "/distributor-stock",
          icon: PiVan,
          breadcrumbs: true,
        },
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        }
      );
    } else if (roles.any(["location_admin"])) {
      inventoryItems.push(
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        },
        {
          id: "return-logs",
          title: "Return Logs",
          url: "/return-logs",
          icon: MdAssignmentReturn,
          breadcrumbs: true,
        }
      );
    }
  } else if (inventorySettings.stock_level === "admin") {
    if (roles.any(["super_admin", "admin"])) {
      inventoryItems.push(
        {
          id: "admin-stock",
          title: "Admin stock",
          url: "/admin-stock",
          icon: BsBuildings,
          breadcrumbs: true,
        },
        {
          id: "distributor-stock",
          title: "Distributor stock",
          url: "/distributor-stock",
          icon: PiVan,
          breadcrumbs: true,
        },
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: MdOutlineFastfood,
          breadcrumbs: true,
        }
      );
    } else if (roles.any(["distributor"])) {
      inventoryItems.push(
        {
          id: "distributor-stock",
          title: "Distributor stock",
          url: "/distributor-stock",
          icon: PiVan,
          breadcrumbs: true,
        },
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        }
      );
    } else if (roles.any(["location_admin"])) {
      inventoryItems.push(
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        },
        {
          id: "return-logs",
          title: "Return Logs",
          url: "/return-logs",
          icon: MdAssignmentReturn,
          breadcrumbs: true,
        }
      );
    }
  } else if (inventorySettings.stock_level === "location") {
    if (
      roles.any([
        "super_admin",
        "admin",
        "machine_admin",
        "distributor",
        "location_admin",
      ])
    ) {
      inventoryItems.push(
        {
          id: "location-stock",
          title: "Location stock",
          url: "/location-stock",
          icon: StoreIcon,
          breadcrumbs: true,
        },
        {
          id: "return-logs",
          title: "Return Logs",
          url: "/return-logs",
          icon: MdAssignmentReturn,
          breadcrumbs: true,
        }
      );
    }
  }

  if (inventorySettings.enable_filling_person_stock) {
    inventoryItems = [
      ...inventoryItems,
      {
        id: "filling-allocation",
        title: "Filling allocation",
        url: "/filling-allocation",
        icon: MdDeliveryDining,
        breadcrumbs: true,
      },
    ];
  }
  if (roles.any(["super_admin"])) {
    menuItems.push({
      id: "inventory",
      title: "Inventory",
      children: [
        {
          id: "inventory-settings",
          title: "Inventory settings",
          url: "/inventory-settings",
          icon: BsBuildingFillGear,
          breadcrumbs: true,
        },
        {
          id: "manage-locations",
          title: "Manage locations",
          url: "/locations",
          icon: LiaMapMarkedAltSolid,
          breadcrumbs: true,
        },
        ...inventoryItems,
      ],
    });
  } else if (roles.any(["admin"])) {
    menuItems.push({
      id: "inventory",
      title: "Inventory",
      children: [
        {
          id: "manage-locations",
          title: "Manage locations",
          url: "/locations",
          icon: LiaMapMarkedAltSolid,
          breadcrumbs: true,
        },
        ...inventoryItems,
      ],
    });
  } else if (
    roles.any([
      "machine_admin",
      "distributor",
      "location_admin",
      "filling_person",
    ])
  ) {
    menuItems.push({
      id: "inventory",
      title: "Inventory",
      children: inventoryItems,
    });
  }

  if (roles.any(["vending_machine"])) {
    menuItems.push({
      id: "accounts",
      title: "Manage user accounts",
      children: [
        {
          id: "customer_profile",
          title: "Customers",
          url: "/customer-profiles",
          icon: FaRegUser,
          breadcrumbs: true,
        }
      ],
    });
  }

  if (roles.any(["super_admin"])) {
    menuItems.push(
      {
        id: "accounts",
        title: "Manage user accounts",
        children: [
          {
            id: "admin-accounts",
            title: "Admin accounts",
            url: "/admin-accounts",
            icon: MdOutlineAdminPanelSettings,
            breadcrumbs: true,
          },
          {
            id: "distributors",
            title: "Distributors",
            url: "/distributors",
            icon: CgUserList,
            breadcrumbs: true,
          },
          {
            id: "filling-persons",
            title: "Filling persons",
            url: "/filling-persons",
            icon: AiOutlineUserSwitch,
            breadcrumbs: true,
          },
          {
            id: "location-admin",
            title: "Location admin",
            url: "/location-admin",
            icon: RiMapPinUserLine,
            breadcrumbs: true,
          },
          {
            id: "machine-admin",
            title: "Machine admin",
            url: "/machine-admin",
            icon: BsPersonVideo3,
            breadcrumbs: true,
          },
          {
            id: "customer_profile",
            title: "Customers",
            url: "/customer-profiles",
            icon: FaRegUser,
            breadcrumbs: true,
          },
        ],
      },
      {
        id: "third_party_services",
        title: "Third party services",
        children: [
          {
            id: "sms_provider",
            title: "SMS service provider",
            url: "/sms-provider",
            icon: TextsmsIcon,
            breadcrumbs: true,
          },
          {
            id: "alert_settings",
            title: "Alert settings",
            url: "/alert-settings",
            icon: NotificationsNoneIcon,
            breadcrumbs: true,
          },
        ],
      }
    );
  }

  if (roles.any(["admin"])) {
    menuItems.push({
      id: "accounts",
      title: "Manage user accounts",
      children: [
        {
          id: "distributors",
          title: "Distributors",
          url: "/distributors",
          icon: CgUserList,
          breadcrumbs: true,
        },
        {
          id: "filling-persons",
          title: "Filling persons",
          url: "/filling-persons",
          icon: AiOutlineUserSwitch,
          breadcrumbs: true,
        },
        {
          id: "location-admin",
          title: "Location admin",
          url: "/location-admin",
          icon: RiMapPinUserLine,
          breadcrumbs: true,
        },
        {
          id: "machine-admin",
          title: "Machine admin",
          url: "/machine-admin",
          icon: BsPersonVideo3,
          breadcrumbs: true,
        },
        {
          id: "customer_profile",
          title: "Customers",
          url: "/customer-profiles",
          icon: FaRegUser,
          breadcrumbs: true,
        },
      ],
    });
  }

  if (roles.any(["machine_admin"])) {
    menuItems.push({
      id: "accounts",
      title: "Manage user accounts",
      children: [
        {
          id: "filling-persons",
          title: "Filling persons",
          url: "/filling-persons",
          icon: AiOutlineUserSwitch,
          breadcrumbs: true,
        },
        {
          id: "customer_profile",
          title: "Customers",
          url: "/customer-profiles",
          icon: FaRegUser,
          breadcrumbs: true,
        },
      ],
    });
  }

  return menuItems;
};
